import { Directive, forwardRef } from '@angular/core';
import { AbstractControl, NG_ASYNC_VALIDATORS } from '@angular/forms';
import { ErrorService } from '../../services/error.service';
import { OrderTemplateService } from '../../services/order-template.service';

@Directive({
	selector: '[appTemplateExists][formControlName],[appTemplateExists][formControl],[appTemplateExists][ngModel]',
	providers: [
		{
			provide: NG_ASYNC_VALIDATORS,
			useExisting: forwardRef(() => TemplateExistsValidatorDirective),
			multi: true
		}
	]
})
export class TemplateExistsValidatorDirective {

	constructor(private _errorService: ErrorService,
				private _orderTemplateService: OrderTemplateService) {
	}

	validate(c: AbstractControl): Promise<{ [key: string]: any }> {
		return new Promise(resolve => {
			if (c.value == null || c.value.length === 0) {
				resolve(null);
			} else {
				this._orderTemplateService.checkIfTemplateNameExists(c.value).subscribe((response) => {
						if (!response) {
							resolve(null);
						} else {
							resolve({templateExists: true});
						}
					}, (error) => {
						this._errorService.error(true, error, 'templateNameIsValid Failed');
					}
				);
			}
		});
	}

}
